import Vue from 'vue'
import {pathOr} from 'ramda'

Vue.filter('pathOr', function(value, path, or = '') {
  return pathOr(or, path, value)
})
